import { Component } from 'react';
// import { Router } from './../../configs/routes';
import cx from 'classnames';
import styles from './../../styles/invest/pennyDropView.scss';
import { Api } from './../../api';
import Loader from './../ui/Loader';

const api = new Api();

interface Props {
  bankAccountStatus: any;
  userDetails: any;
  handleChangeDetails?: () => void;
  dismissModal: () => void;
  isTimeOut: boolean;
  isRedemption?: boolean;
}
interface State {
  uploadDoc: boolean;
  imgURL: string;
  bankDetailsSubmitted: boolean;
  isUploading: boolean;
  bankValidationProof: any;
}
class PennyDropView extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      uploadDoc: false,
      imgURL: '',
      bankDetailsSubmitted: false,
      isUploading: false,
      bankValidationProof: {},
    };
  }

  public handleUploadDoc = () => {
    this.setState({
      uploadDoc: true,
    });
  };

  public handleChange = (e: any) => {
    this.setState({
      imgURL: URL.createObjectURL(e.target.files[0]),
      bankValidationProof: e.target.files[0],
    });
  };

  public handleRemoveImg = () => {
    this.setState({
      imgURL: '',
    });
  };

  public handleSubmitBankDetails = (e: any) => {
    e.preventDefault();
    const { bankValidationProof } = this.state;
    const { userDetails } = this.props;
    const { userPersonalDetails } = userDetails;
    const {
      accountNo,
      ifscCode,
      nameOfBank,
      cityOfBank,
    } = userDetails.userBankDetails;
    const { fullName = '' } = userPersonalDetails || {};
    const userBankDetails = {
      accountNumber: accountNo,
      ifscCode,
      bankName: nameOfBank,
      branchName: cityOfBank,
      userNameAsPerBankAccount: fullName,
      bankValidationProof,
    };
    this.setState({ isUploading: true }, async () => {
      const response = await api.postAccountDetails(userBankDetails);

      if (response) {
        this.setState({ isUploading: false });
        if (response.code === 'BAD_REQUEST_ERROR') {
          this.setState({ bankDetailsSubmitted: false });
          return;
        } else if (response.code === 200) {
          // BLACK-2606, After penny drop doc upload without verifying, replacing the primary bank issue
          // await api.updateUserDetails(userDetails, 'PRE_PAYMENT_CHECKS');
          this.setState({
            bankDetailsSubmitted: true,
          });
        }
      }
    });
  };
  public getUploadDocView() {
    const { imgURL, isUploading, bankDetailsSubmitted } = this.state;
    const { dismissModal } = this.props;
    if (isUploading) {
      return (
        <div className="text-center">
          <Loader size="20px" />
          <p className="font--bold text--md mt10">Uploading</p>
        </div>
      );
    }

    if (bankDetailsSubmitted) {
      return (
        <div className={cx(styles['bank-details'], 'text-center')}>
          <div>Thank you sharing the documents</div>
          <div className={cx(styles['acc-clr-grey'])}>
            Our support team will contact you within the next 24 hours with the
            required action{' '}
          </div>
          <button
            onClick={dismissModal}
            className="btn btn-blue-solid full-width mt30"
          >
            Done
          </button>
        </div>
      );
    }
    return (
      <form
        className={cx(styles['upload-form'], 'text-center')}
        onSubmit={this.handleSubmitBankDetails}
      >
        {imgURL && imgURL.length > 0 ? (
          <div className={cx(styles['img-preview'])}>
            <img
              className={cx(styles['doc-preview'], 'full-width')}
              src={imgURL}
            />
            <div
              className={cx(styles['clear-img'])}
              onClick={this.handleRemoveImg}
            >
              x
            </div>
          </div>
        ) : (
          <label className={cx(styles['bank-doc'])} htmlFor="file">
            <input
              type="file"
              id="file"
              accept=".jpg, .jpeg, .png"
              className={cx(styles['file-input'])}
              onChange={this.handleChange}
            />
          </label>
        )}
        <button type="submit" className="btn btn-blue-solid full-width mt30">
          Upload
        </button>
      </form>
    );
  }

  public render() {
    const {
      bankAccountStatus,
      userDetails,
      handleChangeDetails,
      isTimeOut,
      isRedemption,
    } = this.props;
    const { accountNo, ifscCode, nameOfBank } = userDetails.userBankDetails;
    const { fullName = '' } = userDetails.userPersonalDetails || {};
    const { uploadDoc } = this.state;

    if (bankAccountStatus === 'ACTIVE') {
      return (
        <div className="text-center p60">
          <img
            src="https://assets1.cleartax-cdn.com/clearsave/images/1632994592_group18140617.svg"
            className="aligner"
          />
          <p className="font--bold text--md mt20 lil-text-black">
            Bank verified
          </p>
          <p className="text--md mt20">Please wait...</p>
        </div>
      );
    } else if (
      bankAccountStatus === 'TECHNICAL_ERROR' ||
      bankAccountStatus === 'INVALID' ||
      bankAccountStatus === 'NAME_CHECK_FAILED' ||
      isTimeOut
    ) {
      const errorMsg =
        bankAccountStatus === 'NAME_CHECK_FAILED'
          ? 'the name submitted to the bank'
          : 'your account details';
      return (
        <div>
          {uploadDoc ? (
            this.getUploadDocView()
          ) : (
            <div className="text-center p60">
              <img
                src="https://assets1.cleartax-cdn.com/clearsave/images/1632995473_group181406171.svg"
                className="aligner"
              />
              <p className="font--bold text--md mt20 lil-text-black">
                Bank not verified
              </p>
              <p className={cx(styles['acc-clr-grey'], 'text--md mt10')}>
                Our bank verification system has found issues. To be safe, we
                are pausing your order. Your order couldn’t be processed. Don’t
                worry! Your money is safe.{' '}
              </p>
              <div className={cx(styles['bank-details'])}>
                <div className="card p15 text--md">
                  <div className="font--bold text-left">
                    Please check your bank account details
                  </div>
                  <div className="font--12 font--red">
                    There seems to be a mismatch in {errorMsg}
                  </div>
                  <hr className="mt10 mb10" />
                  <div>
                    <div className={cx(styles['flex-acc-item'])}>
                      <div className={cx(styles['acc-clr-grey font--12'])}>
                        Account Number
                      </div>
                      <div className="font--bold">{accountNo}</div>
                    </div>
                    <div className={cx(styles['flex-acc-item'], 'mt10')}>
                      <div className={cx(styles['acc-clr-grey font--12'])}>
                        IFSC Code
                      </div>
                      <div className="font--bold">{ifscCode}</div>
                    </div>
                    <div className={cx(styles['flex-acc-item'], 'mt10')}>
                      <div className={cx(styles['acc-clr-grey font--12'])}>
                        Bank
                      </div>
                      <div className="font--bold">{nameOfBank}</div>
                    </div>
                    <div className={cx(styles['flex-acc-item'], 'mt10')}>
                      <div className={cx(styles['acc-clr-grey font--12'])}>
                        Name
                      </div>
                      <div className="font--bold">{fullName}</div>
                    </div>
                  </div>
                </div>
                {!isRedemption ? (
                  <div>
                    <button
                      className="btn full-width mt30 btn-blue-solid"
                      onClick={handleChangeDetails}
                    >
                      <img
                        src="https://assets1.cleartax-cdn.com/clearsave/images/1632203129_layer21.svg"
                        className="inline"
                      />
                      <span className="verticle-align-top ml5 text--md">
                        Change details
                      </span>
                    </button>
                    <div className="mt10 mb10">OR</div>
                  </div>
                ) : null}
                <button
                  className="btn full-width btn-blue-solid text--md"
                  onClick={this.handleUploadDoc}
                >
                  Upload cancelled cheque / passbook
                </button>
                <div className="text--md mt30">
                  Need help?{' '}
                  <a
                    href="mailto:invest@cleartax.in"
                    className="font--blue font--bold"
                  >
                    email us
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }
    return (
      <div className="text-center p60">
        <img
          src="https://assets1.cleartax-cdn.com/clearsave/images/1632994592_group18140617.svg"
          className="aligner"
        />
        <p className="font--bold text--md mt20 lil-text-black">
          Verifying bank account
        </p>
        <p className={cx(styles['acc-clr-grey'], 'text--md mt10')}>
          We’ll deposit ₹1 to your bank account to verify
        </p>
      </div>
    );
  }
}

export default PennyDropView;



// WEBPACK FOOTER //
// ./components/common/pennyDropView.tsx